import React, { Component } from 'react';
import { select, arc, pie, mouse } from 'd3';

import './Donut.css';

class Donut extends Component {

  state = {
    width: 0,
    height: 0,
    tooltip: { display: 'none', x: 0, y: 0 }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate() {
    if (this.props.data) this.updateDonut();
  }

  updateDimensions = () => {
    if (!this.container) return;
    const width = this.container.clientWidth,
          height = this.props.height;
    if (this.state.width !== width || this.state.height !== height) this.setState({ width, height });
  }

  updateDonut = () => {
    const { data, colors } = this.props;
    const { width, height } = this.state;
    const format = this.props.format || (value => value);

    const chart = select(this.container).select("svg").select("g"),
          radius = Math.min(width, height) / 2;

    const pieChart = pie()
        .sort(null)
        .value(d => d.value);

    const path = arc()
      .outerRadius(radius - 10)
      .innerRadius(radius - 60);

    const label = arc()
        .outerRadius(radius - 40)
        .innerRadius(radius - 30);

    const arcs = chart.selectAll(".arc").data(pieChart(data));

    arcs.exit().remove();

    arcs.enter()
      .append("path").attr("d", path).attr("class", d => "arc " + d.data.key)
      .merge(arcs)
         .attr("fill", d => colors[d.data.key] )
         .attr("d", path)
         .on('mousemove', d => {
          const position = mouse(this.container);
            this.setState( {
              tooltip: {
                display: 'block',
                x: position[0] + 12,
                y: position[1],
                text: format(d.value)
              }
            })
          })
        .on('mouseleave', () => {
            this.setState( {
              tooltip: {
                display: 'none',
                x: 0,
                y: 0,
                text: ''
              }
            })
        });

    const labels = chart.selectAll(".label").data(pieChart(data));

    labels.exit().remove();

    labels.enter()
      .append("text").attr("class", d => "label " + d.data.key)
      .merge(labels)
        .attr("transform", d => "translate(" + label.centroid(d) + ")")
        .attr("dy", "0.35em")
        .text(d => Math.round(d.data.fraction*100)+"%");

  }

  render() {
    const { width, height } = this.state;
    const { display, x, y, text } = this.state.tooltip;

    const containerStyle = {
      position: 'relative'
    }
    const tooltipStyle = {
      display: display,
      position: 'absolute',
      left: x,
      top: y
    }

    return (
      <div className="Donut" ref={container => this.container = container} style={containerStyle} >
        <svg
          width={width}
          height={height} >
          <g transform={"translate(" + width / 2 + "," + height / 2 + ")"} />
        </svg>
         <div className="tooltip" style={tooltipStyle}><span>{text}</span></div>
      </div>
    );
  }
}

export default Donut;



// WEBPACK FOOTER //
// ./src/components/Donut/Donut.js